import { createAction, props } from '@ngrx/store';

export enum TeamsActions {
  TeamsRequested = '[Teams] Teams Requested',
  TeamsLoaded = '[Teams] Teams Loaded',
  TeamsError = '[Teams] Teams Error',
  TeamAddRequested = '[Teams] Add Team Requested',
  TeamAddSuccess = '[Teams] Add Team Success',
  TeamUpdateRequested = '[Teams] Update Team Requested',
  TeamUpdateSuccess = '[Teams] Update Team Success',
  TeamDeleteRequested = '[Teams] Delete Team Requested',
  TeamDeleteSuccess = '[Teams] Delete Team Success'
}

export const TeamsRequested = createAction(TeamsActions.TeamsRequested);

export const TeamsLoaded = createAction(TeamsActions.TeamsLoaded,
  props<{ teams: [] }>());

export const TeamsError = createAction(TeamsActions.TeamsError);

export const TeamAddRequested = createAction(
  TeamsActions.TeamAddRequested,
  props<{ formData: any; userId: string , users: any[]}>()
);

export const TeamAddSuccess = createAction(
  TeamsActions.TeamAddSuccess,
  props<{ team: any, users: any[] }>()
);

export const TeamUpdateRequested = createAction(
  TeamsActions.TeamUpdateRequested,
  props<{ formData: any; userId: string, users: any[] }>()
);

export const TeamUpdateSuccess = createAction(
  TeamsActions.TeamUpdateSuccess,
  props<{ team: any, users: any[] }>()
);

export const TeamDeleteRequested = createAction(
  TeamsActions.TeamDeleteRequested,
  props<{ teamId: string }>()
);

export const TeamDeleteSuccess = createAction(
  TeamsActions.TeamDeleteSuccess,
  props<{ teamId: string }>()
);
